import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import BreathworkUsersTable from '../../../BreathworkHub/BreathworkUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyBreathworkUsers } from './companyBreathworkApi';

/**
 * Company Breathwork → Employees/Members list.
 * Every user of the current population appears (never-practised ones with
 * dashes, sorted last); a row opens their breathwork profile.
 */
const CBreathworkUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyBreathworkUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Breathwork — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and their breathwork activity. Open a user
        to see their full breathwork profile.
      </p>

      <BreathworkUsersTable
        fetcher={fetcher}
        showCompanyColumn={false}
        onOpenUser={(rowData) => navigate(`/${slug}/breathwork/user?userId=${rowData?._id}`)}
        tableName="company_breathwork_users"
      />
    </div>
  );
};

export default CBreathworkUsers;
